import React from 'react'
import { NumberPad } from '@/components'
import { useWithdrawStore } from '@/store/useWithdrawStore'
import { useGetOnRampPricePerUnit } from '@/domain'
import { useAppPreferencesStore } from '@/store/useAppPreferencesStore'
import type { CryptoCode, FiatCode } from '@/constants/currencyCodes'

export const WithdrawNumberPad: React.FC = () => {
  // Store state
  const isFiatMode = useWithdrawStore((state) => state.isFiatMode)
  const fiatAmount = useWithdrawStore((state) => state.fiatAmount)
  const cryptoAmount = useWithdrawStore((state) => state.cryptoAmount)
  const setCryptoAmount = useWithdrawStore((state) => state.setCryptoAmount)
  const setFiatAmount = useWithdrawStore((state) => state.setFiatAmount)
  const selectedCryptoWalletData = useWithdrawStore(
    (state) => state.selectedCryptoWalletData,
  )
  const shakeComponent = useWithdrawStore((state) => state.shakeComponent)
  const displayCurrency = useAppPreferencesStore(
    (state) => state.displayCurrency,
  )

  // Проверяем состояние загрузки курса валют
  const {
    isLoading: isLoadingOnRampPrice,
    isFetching: isFetchingOnRampPrice,
  } = useGetOnRampPricePerUnit({
    crypto: (selectedCryptoWalletData?.code as CryptoCode) || 'USDT',
    fiat: (displayCurrency?.isin as FiatCode) || 'USD',
  })

  const isLoading = isLoadingOnRampPrice || isFetchingOnRampPrice

  return (
    <NumberPad
      isFiatMode={isFiatMode}
      fiatAmount={fiatAmount}
      cryptoAmount={cryptoAmount}
      setFiatAmount={setFiatAmount}
      setCryptoAmount={setCryptoAmount}
      selectedCurrency={selectedCryptoWalletData}
      shakeComponent={shakeComponent}
      maxLength={12}
      disabled={isLoading}
    />
  )
}
